const featureLibraryMap = {
    microPython: {
        ultrasonic: {
            filename: 'hcsr04.py',
            name: 'HCSR04',
            link: 'https://raw.githubusercontent.com/rsc1975/micropython-hcsr04/master/hcsr04.py'
        }
    }
};

export default featureLibraryMap